import { render, staticRenderFns } from "./ResidentialPropertiesForSale.vue?vue&type=template&id=31e07f7a&"
import script from "./ResidentialPropertiesForSale.vue?vue&type=script&lang=ts&"
export * from "./ResidentialPropertiesForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports